<script setup lang="ts">
import type { SocialLinksContainerSchema } from 'types/storyblok/social-links-container'
import { backgroundStyling } from 'lib/storyblok'

// import navItem from '~/components/storyblok/NavItem.vue'

interface Props {
  story: SocialLinksContainerSchema
  position?: number
}

const props = withDefaults(defineProps<Props>(), {
  position: -1,
})

// const style = computed(() => {
//   return `${props.story.mobile_columns} ${props.story.desktop_columns}`
// })

const background = computed(() => {
  return backgroundStyling(props.story)
})
</script>

<template>
  <div v-editable="story" :class="story.visibility">
    <div class="e-socialLinksContainer social" :style="background">
      <NavItem
        v-for="(item, index) in story.blocks"
        :key="`grid-item-${index}`"
        class="p-flexItem"
        :story="item.link"
      >
        <img :src="item.image" :alt="item.display_name">
      </NavItem>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.e-socialLinksContainer {
  padding-top: 2rem;
  padding-bottom: 2rem;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: row;
  .p-flexItem {
    width: 3.6rem;
    padding: 0 1rem;
    box-sizing: unset;
  }
}
</style>
